export default __webpack_public_path__ + "static/Buttons-ae8eac65d7ef9262bf6edc10c2799154.png";